require("./showExtantCost.scss");

// @ vendor
const React = require("react");
const { withRouter } = require("react-router-dom");
const PropTypes = require("prop-types");
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const BrokerExanteProfitabilityCosts = require("components/commons/brokerExanteProfitabilityCosts/brokerExanteProfitabilityCosts");
const OKModal = require('components/commons/OKModal/OKModal');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const {
    formatAmount,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require('utilities/currencyHelper');

// @ constants
const {
    CHARGE_ACCOUNT_PREFIX,
    FIRST_STEP,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    POTENTIAL_SELL_STOCKS_COSTS,
    POTENTIAL_COST,
    POTENTIAL_COST_TYPE
} = require('constants/index');

class ShowExtantCost extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.buildDetails = this.buildDetails.bind(this);
        this.buildLeftColumn = this.buildLeftColumn.bind(this);
        this.buildRightColumn = this.buildRightColumn.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    componentDidMount() {
        const { fetchExtantCostDetails, history } = this.props
        fetchExtantCostDetails(history);
    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('broker-stocksBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('broker-stocksBuyStep1ForTheBestLabel');
        } else {
            return formatText('broker-stocksBuyStep1LimitedLabel');
        }
    }

    buildLeftColumn() {
        const { productFile, step1, immStocksBuy, immStocksContracts } = this.props;
        const PREFIX = 'brokerBuyStockExAnte-';
        const titles =  immStocksBuy.get('confirmationData').titulosImporteAproximado;
        const orderType = step1.get('orderType');
        const dateFormat = formatText('broker-stocksLikeHeaderDateFormat');
        const validityDate = step1.get('validityDate').format(dateFormat);
        const orderTypeText = this.getOrderType(orderType);
        const companyName = productFile.get('companyName');
        const marketCode = productFile.get('marketCode');
        const marketInfo = `${companyName} (${marketCode})`
        const selectedOption = immStocksBuy.getIn([
            'steps',
            FIRST_STEP,
            'stocksContractSelectedValue'
        ]);
        const selectedAccount = immStocksContracts.get(selectedOption);

        const accountOwner = selectedAccount.get('firstTitular');
        const productNumber = selectedAccount.get('productNumber');
        const contractNumber = selectedAccount.get('walletNumber');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const accountName = selectedAccount.get('associatedAccountAlias');
        const accountNumber = selectedAccount.get('associatedAccount');
        const walletBalance = selectedAccount.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = selectedAccount.getIn(['associatedAccountBalance', 'currency']);
        const balanceLabel = formatText(`${PREFIX}balanceLabel`);

        const descriptionAccount = `${accountName} ${accountNumber} (${balanceLabel} ${formatAmount(walletBalance)} ${formatCurrency(walletCurrency)})`
        let estimatedAmount = `${formatWithoutRound(walletBalance)} ${formatCurrency(walletCurrency)}`;
        const dataExtant = immStocksBuy.get('extantCostData');
        const estimatedBaseAmount = !!dataExtant && dataExtant.get('estimatedBaseAmount');
        const estimatedBaseAmountExchanged = !!dataExtant && dataExtant.get('estimatedBaseAmountExchanged');
        if(!!estimatedBaseAmount){
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            if (!!estimatedBaseAmountExchanged) {
                const estimatedBaseAmountExchangedValue=estimatedBaseAmountExchanged.get('amount');
                const estimatedBaseAmountExchangedCurrency=estimatedBaseAmountExchanged.get('currency')
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(
                    estimatedBaseAmountCurrency
                )} | ${formatWithoutRound(
                    estimatedBaseAmountExchangedValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountExchangedCurrency)}`;
            } else {
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountCurrency)}`;
            }
        }

        return (
            <div className="broker-buy-stock-description__left-column-container">
                <div className="broker-buy-stock-description__column-title">
                    <FormattedText value="brokerBuyStockExtantCost-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label={`${PREFIX}stockTitleLabel`}
                    data={marketInfo}
                />
                <BrokerDataItem
                    label={`${PREFIX}estimatedAmount`}
                    data={estimatedAmount}
                    tooltipTitleKey={`brokerBuyStockExAnte-estimatedAmountTooltipTitle`}
                    tooltipContentKey={`brokerBuyStockExAnte-estimatedAmountComplexTooltip`}
                    eventCategory="orden compra acciones/paso 2"
                    eventTag={"orden de compra/importe base estimado"}
                    complexTooltip
                />
                <BrokerDataItem
                    label={`${PREFIX}titlesLabel`}
                    data={titles}
                />
                <BrokerDataItem
                    label={`${PREFIX}stockTypeTitle`}
                    data={orderTypeText}
                />
                <BrokerDataItem
                    label={`${PREFIX}validityLabel`}
                    data={validityDate}
                />
                <BrokerDataItem
                    label={`${PREFIX}contractTitleLabel`}
                    data={chargeAccount}
                />
                <BrokerDataItem
                    label={`${PREFIX}firstOwnerLabel`}
                    data={accountOwner}
                />
                <BrokerDataItem
                    label={`${PREFIX}associateAccountLabel`}
                    data={descriptionAccount}
                />
            </div>
        );
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    buildModalContent(profitabilityData) {
        return(
            <div>
                <h3>
                    <FormattedText value="brokerBuyStockExAnte-profitabilitySection_modalTitle" />
                </h3>
                <p>
                    <FormattedText value="brokerBuyStockExAnte-profitabilitySection_modalContent1" />
                </p>
                <p>
                    <FormattedText value="brokerBuyStockExAnte-profitabilitySection_modalContent2" />
                </p>
                <p>
                    <FormattedText value="brokerBuyStockExAnte-profitabilitySection_modalContent3" />
                </p>
                <div className="broker-buy-stock-description__profitability-container">
                    <BrokerExanteProfitabilityCosts
                        context="brokerBuyStockExAnteProfitability"
                        section={profitabilityData.merge({
                                hidden: false,
                                type: 'SECTION'
                        })}
                    />
                </div>
                <p>
                    <FormattedText value="brokerBuyStockExAnte-profitabilitySection_modalFooter" />
                </p>
            </div>
        )
    }

    buildProfitabilitySection(profitabilityData) {
        const link = (
            <OKLink
                modifier="emphasize"
                onClick={() => this.handleToggleModal()}
                extraClass="broker-buy-stock-description__description-link"
            >
                <FormattedText value="brokerBuyStockExAnte-profitabilitySection_descriptionLink" />
            </OKLink>
        );
        const modalContent = this.buildModalContent(profitabilityData)
        const totalProfitability = !!profitabilityData.get('total')
            ? !!profitabilityData.getIn(['total', 'percentage'])
                ? formatPercentage(profitabilityData.getIn(['total', 'percentage']))
                : '0'
            : '0'
        return(
            <div>
                <OKModal
                    content={modalContent}
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleModal}
                    footerType="navigation"
                    size="large"
                    primaryButtonText="brokerBuyStockExAnte-profitabilitySection_modalButton"
                    onPrimaryButtonClick={this.handleToggleModal}
                />
                <div>
                    <p className="broker-buy-stock-description__column-title">
                        <FormattedText value="brokerBuyStockExAnte-profitabilitySection_title" />
                    </p>
                    <p className="broker-buy-stock-description__description">
                        <FormattedTextWithComponents
                            value="brokerBuyStockExAnte-profitabilitySection_description"
                            injectedComponents={[totalProfitability, link]}
                        />
                    </p>
                </div>
            </div>
        )
    }

    buildRightColumn() {
        const { immStocksBuy, showProfitabilitySection } = this.props;
        const dataExtant = immStocksBuy.getIn(['extantCostData']);
        const exAnteCostList = !!dataExtant && dataExtant.getIn(['exAnteCostList']);
        let data, profitabilitySection, potentialSellStocksCostsText;
        if (immStocksBuy.getIn(['fetchingExtantConst'])) {
            data = <LoadingSection />;
        } else if (exAnteCostList) {
            data = exAnteCostList.map((item, index) => (
                item.get('type')  !== POTENTIAL_COST &&
                    (
                        <BrokerExAntSection
                            context="brokerBuyStockExAnte"
                            eventCategory="orden compra fondos/paso 2"
                            section={item}
                            key={index}
                            complexTooltip={true}
                        />
                    )
            ));
            const profitabilityItem = exAnteCostList.find(
                (item) => item.get("type") === "PROFITABILITY"
            );

            if (!!profitabilityItem && showProfitabilitySection) {
                profitabilitySection = this.buildProfitabilitySection(profitabilityItem);
            }

            const potentialSellStocksCosts  = exAnteCostList.find(
                (item) => item.get("descriptionKey") === POTENTIAL_SELL_STOCKS_COSTS
            );

            if (potentialSellStocksCosts && potentialSellStocksCosts.get('type') === POTENTIAL_COST) {
                const dataPotentialCosts = potentialSellStocksCosts.get('details').toJS()[0];
                const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
                const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
                const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
                const formatAmount = `${amount} ${currency}`

                potentialSellStocksCostsText = formatText('brokerBuyStockExAnte-exantCost_potentialCost_footer', [formatAmount, immPercentage]);
            }

        }
        return (
            <div className="broker-buy-stock-description__right-column-container">
                {data}
                <div className="broker-buy-stock-description__right-column-potential-sell-stocks-container">
                    {potentialSellStocksCostsText}
                </div>
                {profitabilitySection}
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="broker-buy-stock-description__title-description">
                    {title}
                </div>
                <div className="broker-buy-stock-description__web-wrapper__extant-cost-container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                <div className="broker-buy-stock-description__footer">
                    {footer}
                </div>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immStocksBuy } = this.props;
        const dataExtant = immStocksBuy.getIn(['extantCostData']);
        const exAnteCostList = !!dataExtant && dataExtant.getIn(['exAnteCostList']);
        const potentialSellStockCosts  = exAnteCostList && exAnteCostList.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_STOCKS_COSTS
        );
        return (
            <div className="broker-buy-stock-description__web-wrapper">
                <div className="broker-buy-stock-description__web-wrapper__extant-cost-container">
                    {this.buildLeftColumn()}
                    {this.buildRightColumn()}
                </div>
                {potentialSellStockCosts && potentialSellStockCosts.get('type') === POTENTIAL_COST_TYPE &&
                    <div className="broker-buy-stock-description__footer">
                        <FormattedText
                            value="brokerBuyStockExAnte-extantCost_footer_description"
                        />
                    </div>
                }
            </div>
        );
    }

    renderContent() {
        return (
            __CONTACT_CENTER__ ? (
                <BlockInfo extraClass="broker-buy-stock-description__block-info">
                    {this.buildDetails(
                        formatText('brokerBuyStockExAnte-extantCost_description_cc'),
                        formatText('brokerBuyStockExAnte-extantCost_footer_description_cc')
                    )}
                </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
            )
        )
    }

    render() {
        const { immStocksBuy } = this.props;
        return (
            immStocksBuy.getIn(['fetchingExtantConst']) ? (
                <LoadingSection />
            ) : (
                this.renderContent()
            )
        )
    }
}

ShowExtantCost.propTypes = {
    history: PropTypes.object.isRequired,
    immStocksBuy: PropTypes.object.isRequired,
    productFile: PropTypes.object.isRequired,
    step1: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object,
    fetchExtantCostDetails: PropTypes.func.isRequired,
    showProfitabilitySection: PropTypes.bool,
};

module.exports.constructor = ShowExtantCost;

export default withRouter(ShowExtantCost);
